// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__940+6","center":"styles_center__5gx3C"};